module.exports = __webpack_public_path__ + "static/media/leeskost-min.8b2f013b.png";